import React from 'react';
import BaseTable, { BaseTableColumn, FieldData } from '../../components/tables/BaseTable';
import { IEmailAIExtractedData } from '../../types/common';

const EmailsForReviewTable = ({
    reviewEmails,
    pagination,
    setPagination,
    totalCount,
    loading,
}:{
    reviewEmails: IEmailAIExtractedData[];
    pagination: { page: number; limit: number; };
    setPagination: (pagination: { page: number; limit: number ;}) => void;
    totalCount: number;
    loading: boolean;
}) => {
    const COLUMNS_TO_RENDER: BaseTableColumn[] = [
        'businessName',
        'dba',
        // 'last4ssn',
        // 'fullName',
        'owners',
        'createdAt',
        'status',
        'resolveManually',
        'notes'
    ];

    return (
        <BaseTable 
            columns={COLUMNS_TO_RENDER}
            data={reviewEmails}
            pagination={pagination}
            setPagination={setPagination}
            totalCount={totalCount}
            loading={loading}
        />
    )
}

export default EmailsForReviewTable;
